import { render, staticRenderFns } from "./krasPlanInfo.vue?vue&type=template&id=4b739616"
import script from "./krasPlanInfo.vue?vue&type=script&lang=js"
export * from "./krasPlanInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b739616')) {
      api.createRecord('4b739616', component.options)
    } else {
      api.reload('4b739616', component.options)
    }
    module.hot.accept("./krasPlanInfo.vue?vue&type=template&id=4b739616", function () {
      api.rerender('4b739616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/plan/krasPlanInfo.vue"
export default component.exports